import { createAction, handleActions } from "redux-actions";
import {
  _getEcommAuthToken,
  _getRetailerAuthToken,
  _getUserInformation,
  _getRetailerInformation,
} from "~shared/httpService/apis";
import ActionTypes from "~shared/constants/actionTypes";
import {setCookie} from "../../../shared/utils/cookie";


const initialState = {
  ecomm_auth: { loading: false, response: {}, hasError: false, error: {} },
  retailer_auth: { loading: false, response: {}, hasError: false, error: {} },
  user_info: { loading: false, response: {}, hasError: false, error: {} },
  retailer_info: { loading: false, response: {}, hasError: false, error: {} },
};

export const getEcommAuthTokenStart = createAction(
  ActionTypes.GET_ECOMM_AUTHENTICATION_TOKEN
);
export const getEcommAuthTokenSuccess = createAction(
  ActionTypes.GET_ECOMM_AUTHENTICATION_TOKEN_SUCCESS,
  (response) => response
);
export const getEcommAuthTokenError = createAction(
  ActionTypes.GET_ECOMM_AUTHENTICATION_TOKEN_ERROR,
  (error) => error
);

export const getEcommAuthToken = (schema) => (dispatch) => {
  dispatch(getEcommAuthTokenStart());
  return _getEcommAuthToken(schema)
    .then((response) => {
      dispatch(getEcommAuthTokenSuccess(response));
      let currentdateobject = new Date();
      let tokenExpiration = new Date();
      tokenExpiration.setTime(
          currentdateobject.getTime() +
          (response?.expires_in*1000)
      );
        setCookie('ecommExpiry',tokenExpiration)
    })
    .catch((error) => {
      dispatch(getEcommAuthTokenError(error));
    });
};

export const getRetailerAuthTokenStart = createAction(
  ActionTypes.GET_RETAILER_AUTHENTICATION_TOKEN
);
export const getRetailerAuthTokenSuccess = createAction(
  ActionTypes.GET_RETAILER_AUTHENTICATION_TOKEN_SUCCESS,
  (response) => response
);
export const getRetailerAuthTokenError = createAction(
  ActionTypes.GET_RETAILER_AUTHENTICATION_TOKEN_ERROR,
  (error) => error
);

export const getRetailerAuthToken = (data) => (dispatch) => {
  dispatch(getRetailerAuthTokenStart());
  return _getRetailerAuthToken(data)
    .then((response) => {
      dispatch(getRetailerAuthTokenSuccess(response));
    })
    .catch((error) => {
      dispatch(getRetailerAuthTokenError(error));
    });
};

export const getUserInformationStart = createAction(
  ActionTypes.GET_ECOMM_USER_INFO
);
export const getUserInformationSuccess = createAction(
  ActionTypes.GET_ECOMM_USER_INFO_SUCCESS,
  (response) => response
);
export const getUserInformationError = createAction(
  ActionTypes.GET_ECOMM_USER_INFO_ERROR,
  (error) => error
);
/* eslint-disable */
export const getUserInformation = (schema, userId) => (dispatch) => {
  dispatch(getUserInformationStart());
  return _getUserInformation(schema, userId)
    .then((response) => {
      dispatch(getUserInformationSuccess(response));
    })
    .catch((error) => {
      //remove the mock response when API is ready
      // const data = {
      //   id: 2,
      //   first_name: "Nithin",
      //   last_name: "",
      //   email: "user@example.com",
      //   current_timezone: "PST",
      // };
      // dispatch(getUserInformationSuccess(data));
      dispatch(getUserInformationError(error));
    });
};

export const getRetailerInformationStart = createAction(
  ActionTypes.GET_ECOMM_RETAILER_INFO
);
export const getRetailerInformationSuccess = createAction(
  ActionTypes.GET_ECOMM_RETAILER_INFO_SUCCESS,
  (response) => response
);
export const getRetailerInformationError = createAction(
  ActionTypes.GET_ECOMM_RETAILER_INFO_ERROR,
  (error) => error
);
/* eslint-disable */
export const getRetailerInformation = (schema) => (dispatch) => {
  dispatch(getRetailerInformationStart());
  return _getRetailerInformation(schema)
    .then((response) => {
      window.default_store_timezone = response.default_store_timezone;
      dispatch(getRetailerInformationSuccess(response));
    })
    .catch((error) => {
      dispatch(getRetailerInformationError(error));
      //remove the mock response when API is ready
      // const data = {
      //   id: 465,
      //   name: "Awesome Pet's",
      //   email: "retailer@example.com",
      //   schema_name: "islandpetcenter",
      //   domain_url: "awesomepets.dev.etailpet.com",
      //   logo: "https://etailpet-dev.s3.amazonaws.com/media/islandpetcenter/logos/logo_moAJVHK.png",
      //   favicon:
      //     "https://etailpet-dev.s3.amazonaws.com/media/islandpetcenter/logos/9-dog-png-image-picture-download-dogs-thumb_xSxYntf_mezci64_j382B5p.png",
      // };
      // dispatch(getRetailerInformationSuccess(data));
    });
};

const reducer = handleActions(
  {
    //GET_ECOMM_AUTHENTICATION_TOKEN
    [ActionTypes.GET_ECOMM_AUTHENTICATION_TOKEN]: (state) => ({
      ...state,
      ecomm_auth: {
        ...state.ecomm_auth,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ECOMM_AUTHENTICATION_TOKEN_SUCCESS]: (state, action) => ({
      ...state,
      ecomm_auth: {
        ...state.ecomm_auth,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ECOMM_AUTHENTICATION_TOKEN_ERROR]: (state, action) => ({
      ...state,
      ecomm_auth: {
        ...state.ecomm_auth,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
    //GET_RETAILER_AUTHENTICATION_TOKEN
    [ActionTypes.GET_RETAILER_AUTHENTICATION_TOKEN]: (state) => ({
      ...state,
      retailer_auth: {
        ...state.retailer_auth,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_RETAILER_AUTHENTICATION_TOKEN_SUCCESS]: (
      state,
      action
    ) => ({
      ...state,
      retailer_auth: {
        ...state.retailer_auth,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_RETAILER_AUTHENTICATION_TOKEN_ERROR]: (state, action) => ({
      ...state,
      retailer_auth: {
        ...state.retailer_auth,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
    //GET_ECOMM_USER_INFO
    [ActionTypes.GET_ECOMM_USER_INFO]: (state) => ({
      ...state,
      user_info: {
        ...state.user_info,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ECOMM_USER_INFO_SUCCESS]: (state, action) => ({
      ...state,
      user_info: {
        ...state.user_info,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ECOMM_USER_INFO_ERROR]: (state, action) => ({
      ...state,
      user_info: {
        ...state.user_info,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
    //GET_ECOMM_RETAILER_INFO
    [ActionTypes.GET_ECOMM_RETAILER_INFO]: (state) => ({
      ...state,
      retailer_info: {
        ...state.retailer_info,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ECOMM_RETAILER_INFO_SUCCESS]: (state, action) => ({
      ...state,
      retailer_info: {
        ...state.retailer_info,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ECOMM_RETAILER_INFO_ERROR]: (state, action) => ({
      ...state,
      retailer_info: {
        ...state.retailer_info,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
  },
  initialState
);

export default reducer;
